// UOM options with preset values
export const UOM_OPTIONS = [
  { value: 'each', label: 'Each' },
  { value: 'piece', label: 'Piece' },
  { value: 'pound', label: 'Pound (lb)' },
  { value: 'ounce', label: 'Ounce (oz)' },
  { value: 'kilogram', label: 'Kilogram (kg)' },
  { value: 'gram', label: 'Gram (g)' },
  { value: 'liter', label: 'Liter (L)' },
  { value: 'milliliter', label: 'Milliliter (mL)' },
  { value: 'gallon', label: 'Gallon (gal)' },
  { value: 'quart', label: 'Quart (qt)' },
  { value: 'pint', label: 'Pint (pt)' },
  { value: 'cup', label: 'Cup' },
  { value: 'tablespoon', label: 'Tablespoon (tbsp)' },
  { value: 'teaspoon', label: 'Teaspoon (tsp)' },
  { value: 'box', label: 'Box' },
  { value: 'case', label: 'Case' },
  { value: 'pack', label: 'Pack' },
];

export const COUNT_TYPE = {
  ADD: 'add',
  REMOVE: 'remove',
  ADJUST: 'adjust',
};
